module.exports = __webpack_public_path__ + "da79163e5c232a4f14c0200da220409b.svg";